import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  onSnapshot,
  query,
  orderBy,
  setDoc,
  where,
  getDoc
} from "firebase/firestore";
import { sendPasswordResetEmail, getAuth } from "firebase/auth";
import { db } from "../firebase/config";
import { auth } from "../firebase/config";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import "./UserManagement.css";

function ZoneManagement() {



  const [pendingColor, setPendingColor] = useState(null);

  const handleZoneColorChange = async (newColor) => {
    if (!selectedZone) return;

    if (newColor === selectedZone.color) return;

    const ok = window.confirm(
      `🎨 "${selectedZone.name}" zonunun rengini değiştirmek istiyor musun?`
    );
    if (!ok) return;

    await updateDoc(doc(db, "zones", selectedZone.id), {
      color: newColor
    });
  };

  const DEFAULT_ZONE_COLORS = {
    "ZONE 1": "#B13928",
    "ZONE 2": "#3F7CB5",
    "ZONE 3": "#FFCE12",
    "ZONE 4": "#77AE5B",
  };
  const [newZoneColor, setNewZoneColor] = useState("#0078d7");
  const [zones, setZones] = useState([]);
  const [newZone, setNewZone] = useState("");
  const [newLocation, setNewLocation] = useState("");
  const [selectedZone, setSelectedZone] = useState(null);

  useEffect(() => {
    if (!selectedZone) return;

    const updated = zones.find(z => z.id === selectedZone.id);

    if (updated) {
      setSelectedZone(updated);
    }
  }, [zones]);


  useEffect(() => {
    const q = query(collection(db, "zones"), orderBy("order", "asc"));
    const unsub = onSnapshot(q, (snap) => {
      setZones(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!zones.length) return;

    zones.forEach((z) => {
      if (!z.color) {
        const defaultColor =
          DEFAULT_ZONE_COLORS[z.name.toUpperCase()];

        if (defaultColor) {
          updateDoc(doc(db, "zones", z.id), {
            color: defaultColor
          });
        }
      }
    });
  }, [zones.length]); // ⚠️ SADECE LENGTH

  const checkActiveProjects = async (zoneName) => {
    const q = query(
      collection(db, "events"),
      where("zone", "==", zoneName),
      where("status", "==", "active")
    );

    const snap = await getDocs(q);
    return !snap.empty;
  };
  // 🔥 ZONELARI DİNLE
  useEffect(() => {
    const q = query(collection(db, "zones"), orderBy("order", "asc"));
    const unsub = onSnapshot(q, (snap) => {
      setZones(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  // ➕ ZONE EKLE
  const addZone = async () => {
    const zoneName = newZone.trim();
    if (!zoneName) return alert("Zone name required");

    const exists = zones.find(
      z => z.name.toLowerCase() === zoneName.toLowerCase()
    );
    if (exists) return alert("⚠️ This zone already exists");

    const color =
      DEFAULT_ZONE_COLORS[zoneName.toUpperCase()] || newZoneColor;

    await setDoc(doc(db, "zones", zoneName), {
      name: zoneName,
      order: zones.length,
      color,
      locations: [],
      createdAt: new Date().toISOString()
    });

    setNewZone("");
    setNewZoneColor(color);
  };



  // ❌ ZONE SİL
  const removeZone = async (z) => {
    // 🔔 HER ZAMAN SOR
    const confirmDelete = window.confirm(
      `❗ "${z.name}" zonu silinsin mi?`
    );
    if (!confirmDelete) return;

    // ⚠️ AKTİF PROJE VAR MI?
    const hasActive = await checkActiveProjects(z.name);

    if (hasActive) {
      const ok = window.confirm(
        `⚠️ ${z.name} için AKTİF projeler var!\nBuna rağmen silmek istiyor musun?`
      );
      if (!ok) return;
    }

    await deleteDoc(doc(db, "zones", z.id));
    setSelectedZone(null);
  };



  // ➕ LOCATION EKLE
  const addLocation = async () => {
    const loc = newLocation.trim();
    if (!loc || !selectedZone) return;

    if (selectedZone.locations.includes(loc)) {
      alert("⚠️ This location already exists");
      return;
    }

    await updateDoc(doc(db, "zones", selectedZone.id), {
      locations: [...selectedZone.locations, loc]
    });

    setPendingColor(null);
    setNewLocation("");
  };

  // ❌ REMOVE LOCATION
  const removeLocation = async (loc) => {
    // 🔔 1️⃣ HER ZAMAN SOR
    const confirmDelete = window.confirm(
      `❗ Are you sure you want to delete the location "${loc}"?`
    );
    if (!confirmDelete) return;

    // 🔎 2️⃣ AKTİF EVENT KONTROLÜ
    const q = query(
      collection(db, "events"),
      where("zone", "==", selectedZone.name),
      where("location", "==", loc),
      where("status", "==", "active")
    );

    const snap = await getDocs(q);

    // ⚠️ 3️⃣ AKTİF EVENT VARSA EK UYARI
    if (!snap.empty) {
      const ok = window.confirm(
        `⚠️ There are ACTIVE events assigned to "${loc}".\n\nDeleting this location may affect existing schedules.\n\nDo you still want to continue?`
      );
      if (!ok) return;
    }

    // 🗑 4️⃣ SİLME
    await updateDoc(doc(db, "zones", selectedZone.id), {
      locations: selectedZone.locations.filter(l => l !== loc)
    });
  };



  return (
    <div className="zones-layout">

      {/* ================= ZONE LIST ================= */}
      <div className="zone-box">
        <h3 className="zone-title">📍 Zones</h3>

        {/* ➕ ADD ZONE */}
        <div className="zone-add">
          <input
            value={newZone}
            onChange={(e) => setNewZone(e.target.value)}
            placeholder="New Zone"
            className="zone-input"
          />

          <button onClick={addZone} className="btn-primary_User">+</button>
        </div>

        {/* 🔁 ZONE ROWS */}
        {zones.map(z => (
          <div
            key={z.id}
            className={`zone-row ${selectedZone?.id === z.id ? "active" : ""}`}
            style={{ borderLeftColor: z.color || "#ccc" }}
            onClick={() => setSelectedZone(z)}
          >
            <div className="zone-row-left">
              <div className="zone-name">{z.name}</div>
              <div className="zone-count">{z.locations.length} loc</div>
            </div>

            <button
              className="btn-icon danger"
              onClick={(e) => {
                e.stopPropagation();
                removeZone(z);
              }}
            >
              🗑 Delete
            </button>
          </div>
        ))}
      </div>

      {/* ================= LOCATION PANEL ================= */}
      {selectedZone && (
        <div className="zone-box">

          <div className="zone-head">
            <h3>📌 {selectedZone.name}</h3>

            <div className="zone-color-wrap">
              <span>Color</span>
              <input
                type="color"
                value={pendingColor ?? selectedZone.color ?? "#cccccc"}
                onChange={(e) => setPendingColor(e.target.value)}
                className="zone-color"
              />
            </div>
          </div>

          {/* 💾 SAVE COLOR */}
          <button
            className="btn-save"
            onClick={async () => {
              if (!pendingColor || pendingColor === selectedZone.color) return;

              const ok = window.confirm(
                `🎨 "${selectedZone.name}" zonunun rengini değiştirmek istiyor musun?`
              );
              if (!ok) return;

              await updateDoc(doc(db, "zones", selectedZone.id), {
                color: pendingColor
              });

              setPendingColor(null);
            }}
          >
            💾 Kaydet
          </button>

          {/* ➕ ADD LOCATION */}
          <div className="zone-add">
            <input
              value={newLocation}
              onChange={(e) => setNewLocation(e.target.value)}
              placeholder="New Location"
              className="zone-input"
            />
            <button onClick={addLocation} className="btn-primary_User">+</button>
          </div>

          {/* 📍 LOCATION LIST */}
          {selectedZone.locations.map(loc => (
            <div key={loc} className="location-row">
              <span className="location-name">{loc}</span>
              <button
                onClick={() => removeLocation(loc)}
                className="btn-icon danger"
              >
                🗑 DeletefilteredUsers
              </button>
            </div>
          ))}
        </div>
      )}

    </div>
  );


}
export default function UserManagement() {
  const [searchTerm, setSearchTerm] = useState("");
  const [roleFilter, setRoleFilter] = useState("all"); 
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("users"); // users | projects
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newUser, setNewUser] = useState({
    email: "",
    displayName: "",
    role: "user",
  });
  const [loading, setLoading] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);



  // 🔹 Kullanıcıları çek
  const fetchUsers = async () => {
    setLoading(true);

    const snap = await getDocs(collection(db, "users"));
    const list = snap.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .filter((u) => u.email !== "admin@acunmedya.com"); // ❗ admin listede görünmesin

    setUsers(list);
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // 🔹 Yeni kullanıcı ekle
  const handleAddUser = async () => {
    const email = newUser.email.trim().toLowerCase();
    if (!email) return alert("E-posta boş olamaz!");
    if (!email.includes("@")) return alert("Geçerli Email girin!");

    const emailKey = email;

    // 🔥 docId = email olacak şekilde kayıt
    await setDoc(doc(db, "users", emailKey), {
      email: emailKey,
      displayName: newUser.displayName || "",
      role: newUser.role || "user",
      disabled: false,
      createdAt: new Date().toISOString(),
    });

    try {
      await sendPasswordResetEmail(auth, email);
      alert(`📩 Şifre sıfırlama maili gönderildi → ${email}`);
    } catch (err) {
      alert("Mail gönderilemedi: " + err.message);
    }

    setNewUser({ email: "", displayName: "", role: "user" });
    setShowModal(false);
    fetchUsers();
  };


  // 🔹 Kullanıcı sil
  const handleDelete = async (id) => {
    if (!window.confirm("Bu kullanıcı silinsin mi?")) return;
    await deleteDoc(doc(db, "users", id));
    fetchUsers();
  };

  const handleDisableToggle = async (user) => {
    await updateDoc(doc(db, "users", user.id), {
      disabled: !user.disabled
    });
    fetchUsers();
  };
  // 🔹 Rol değiştir
  const handleRoleChange = async (id, role) => {
    await updateDoc(doc(db, "users", id), { role });
    fetchUsers();
  };
  const [cooldowns, setCooldowns] = useState({});
  const handlePasswordReset = async (user) => {
    if (cooldowns[user.id] > 0) return; // zaten bekliyorsa tekrar çalışmasın

    try {
      await sendPasswordResetEmail(auth, user.email);

      // 📩 Popup
      alert(`📩 Şifre sıfırlama maili gönderildi → ${user.email}`);

      // 90 saniye başlat
      setCooldowns(prev => ({ ...prev, [user.id]: 90 }));

      const interval = setInterval(() => {
        setCooldowns(prev => {
          const newTime = prev[user.id] - 1;

          if (newTime <= 0) {
            clearInterval(interval);
            return { ...prev, [user.id]: 0 };
          }

          return { ...prev, [user.id]: newTime };
        });
      }, 1000);
    } catch (err) {
      alert("Mail gönderilemedi: " + err.message);
    }
  };

  const [hideHeader, setHideHeader] = useState(false);

 const filteredUsers = users.filter((u) => {
  const term = searchTerm.toLowerCase();

  const matchesSearch =
    u.email?.toLowerCase().includes(term) ||
    u.displayName?.toLowerCase().includes(term);

  const matchesRole =
    roleFilter === "all" ? true : u.role === roleFilter;

  return matchesSearch && matchesRole;
});
  return (
    <div style={{
      position: "fixed",
      top: window.innerWidth < 768 ? 10 : 20, // Üst header boşluğu
      left: 0,
      right: 0,
      bottom: 0,
      overflowY: "auto",
      padding: "30px 20px",
      background: "#f9fafc"
    }}>
      <button
        className={`logout-modern ${hideHeader && window.innerWidth < 768 ? "hide" : ""}`}
        onClick={() => {
          signOut(auth)
            .then(() => navigate("/login"))
            .catch((err) => console.error("❌ Logout error:", err));
        }}
        title="Logout"
        style={{
          position: "fixed",   // ✅ ekran sabit
          top: "35px",         // ✅ üstten mesafe
          right: "12px",       // ✅ sağdan mesafe
          zIndex: 3000,        // ✅ her şeyin üstünde
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" y1="12" x2="9" y2="12" />
        </svg>
      </button>


      {/* === TAB BUTTONS === */}
      <div
        style={{
          display: "flex",
          gap: 10,
          marginBottom: 20,
          flexWrap: "wrap",
        }}
      >
        <TabButton title="👥 Users" active={activeTab === "users"} onClick={() => setActiveTab("users")} />
        <TabButton title="🏗️ Projects" active={activeTab === "projects"} onClick={() => setActiveTab("projects")} />
        <TabButton
          title="📍 Zones"
          active={activeTab === "zones"}
          onClick={() => setActiveTab("zones")}
        />
      </div>

      {/* === USERS PANEL === */}
      {activeTab === "users" && (
        <>
<div
  style={{
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  }}
>
  {/* 🔍 SEARCH */}
  <input
    type="text"
    placeholder="🔍 Search user..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    style={{
      padding: "8px 10px",
      borderRadius: 6,
      border: "1px solid #ccc",
      minWidth: 180,
    }}
  />

  {/* 🏷 ROLE FILTER */}
  <select
    value={roleFilter}
    onChange={(e) => setRoleFilter(e.target.value)}
    style={{
      padding: "8px 10px",
      borderRadius: 6,
      border: "1px solid #ccc",
      cursor: "pointer",
      minWidth: 140,
    }}
  >
    <option value="all">All Roles</option>
    <option value="admin">Admin</option>
    <option value="user">User</option>
  </select>

  {/* ➕ ADD USER */}
  <button onClick={() => setShowModal(true)} style={addUserBtn}>
    ➕ Add User
  </button>
</div>



          {!isMobile ? (
            /* ===== DESKTOP TABLE ===== */
            <div style={tableWrapper}>
              <table style={tableStyle}>
                <thead style={theadStyle}>
                  <tr>
                    <th style={th}>Email</th>
                    <th style={th}>Name</th>
                    <th style={th}>Role</th>
                    <th style={th}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers.map((u) => (
                    <tr key={u.id} style={{ background: u.disabled ? "#f1f1f1" : "#fff" }}>
                      <td style={td}>{u.email}</td>
                      <td style={td}>{u.displayName || "-"}</td>
                      <td style={td}>
                        <select
                          disabled={u.disabled}
                          value={u.role}
                          onChange={(e) => handleRoleChange(u.id, e.target.value)}
                          style={selectInput}
                        >
                          <option value="user">User</option>
                          <option value="admin">Admin</option>
                        </select>
                      </td>
                      <td style={{ ...td, display: "flex", gap: 8 }}>
                        <button onClick={() => handlePasswordReset(u)} style={resetBtn}>
                          🔑 Reset
                        </button>
                        <button onClick={() => handleDisableToggle(u)} style={{
                          background: u.disabled ? "#4cd964" : "#8e8e93",
                          ...resetBtn
                        }}>
                          {u.disabled ? "Enable" : "Disable"}
                        </button>
                        <button onClick={() => handleDelete(u.id)} style={deleteBtn}>
                          🗑
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            /* ===== MOBILE CARDS ===== */
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {filteredUsers.map((u) => (
                <div
                  key={u.id}
                  style={{
                    background: "#fff",
                    borderRadius: 10,
                    padding: 14,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    opacity: u.disabled ? 0.6 : 1,
                  }}
                >
                  <div style={{ fontWeight: 700 }}>{u.email}</div>
                  <div style={{ fontSize: 13, color: "#666", marginBottom: 8 }}>
                    {u.displayName || "—"}
                  </div>

                  <select
                    disabled={u.disabled}
                    value={u.role}
                    onChange={(e) => handleRoleChange(u.id, e.target.value)}
                    style={{ ...selectInput, width: "100%", marginBottom: 8 }}
                  >
                    <option value="user">User</option>
                    <option value="admin">Admin</option>
                  </select>

                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    <button onClick={() => handlePasswordReset(u)} style={resetBtn}>
                      🔑 Reset Password
                    </button>

                    <button
                      onClick={() => handleDisableToggle(u)}
                      style={{
                        background: u.disabled ? "#8e8e93" : "#4cd964",
                        border: "none",
                        borderRadius: 6,
                        padding: "6px 10px",
                        color: "white",
                        cursor: "pointer",
                        fontWeight: "bold"
                      }}
                    >
                      {u.disabled ? "Disabled" : "Enabled"}
                    </button>

                    <button onClick={() => handleDelete(u.id)} style={deleteBtn}>
                      🗑 Delete User
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

        </>
      )}
      {/* === PROJECTS PANEL === */}
      {activeTab === "projects" && <ProjectManagement />}

      {activeTab === "zones" && <ZoneManagement />}
      {/* === ADD USER MODAL === */}
      {showModal && <AddUserModal newUser={newUser} setNewUser={setNewUser} setShowModal={setShowModal} handleAddUser={handleAddUser} />}
    </div>
  );
}

/* ------------ PROJECT PANEL ------------ */


function ProjectManagement() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [exporting, setExporting] = useState(false);

  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [newProjectName, setNewProjectName] = useState("");
  const [newProjectFlag, setNewProjectFlag] = useState("");

  // ✅ Firestore'dan canlı veri dinle
  useEffect(() => {
    const q = query(collection(db, "projects"), orderBy("order", "asc"));
    const unsub = onSnapshot(q, (snap) => {
      setProjects(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  // ✅ Ekle
  const addProject = async () => {
    if (!newProjectName.trim()) return alert("Project name required!");
    await addDoc(collection(db, "projects"), {
      name: newProjectName.trim(),
      flag: newProjectFlag.trim() || "",
      order: projects.length,
    });
    setNewProjectName("");
    setNewProjectFlag("");
  };

  // ✅ Sil
  const removeProject = async (p) => {
    if (!window.confirm(`"${p.name}" silinsin mi?`)) return;
    await deleteDoc(doc(db, "projects", p.id));
  };

  const exportProjectExcel = async (project) => {
    setExporting(true);

    try {
      // 🔹 1) Events çek
      const q = query(
        collection(db, "events"),
        where("project", "==", project.name)
      );

      const snap = await getDocs(q);

      const rows = snap.docs.map(d => {
        const e = d.data();
        return {
          Project: project.name,
          Zone: e.zone || "",
          Location: e.location || "",
          Date: e.date || "",
          TimeOfDay: e.timeOfDay || "",
          GameOrder: e.gameOrder || "",
          Code: e.gameCode || e.code || "",
          EndingCode: e.endingCode || "",
          Note: e.note || "",
          Draft: e.isDraft ? "YES" : "NO",
          Revised: e.isRevised ? "YES" : "NO",
          Reality: e.isReality ? "YES" : "NO",
          CreatedAt: e.createdAt?.toDate
            ? e.createdAt.toDate().toLocaleString("tr-TR")
            : "",
          RevisedAt: e.revisedAt?.toDate
            ? e.revisedAt.toDate().toLocaleString("tr-TR")
            : "",
          User: e.user || ""
        };
      });

      if (!rows.length) {
        alert("No events found for this project.");
        setExporting(false);
        return;
      }

      // 🔹 2) Excel oluştur
      const XLSX = await import("xlsx");
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Events");

      const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });

      const { saveAs } = await import("file-saver");
      saveAs(
        new Blob([buf]),
        `${project.name}_Events.xlsx`
      );

    } catch (err) {
      console.error(err);
      alert("Export failed");
    }

    setExporting(false);
  };


  // ✅ Yukarı / Aşağı taşı → order güncelle
  const move = async (index, direction) => {
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= projects.length) return;

    const current = projects[index];
    const target = projects[targetIndex];

    await updateDoc(doc(db, "projects", current.id), { order: target.order });
    await updateDoc(doc(db, "projects", target.id), { order: current.order });
  };

  return (
    <div style={projectBox}>
      <h3>🏗️ Project List</h3>
      <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
        <input value={newProjectName} onChange={(e) => setNewProjectName(e.target.value)} placeholder="Project Name" style={input} />
        <input value={newProjectFlag} onChange={(e) => setNewProjectFlag(e.target.value)} placeholder="Flag URL (optional)" style={input} />
        <button onClick={addProject} style={addUserBtn}>➕ Add</button>
      </div>

      {selectedProject && (
        <div
          style={{
            marginTop: 20,
            background: "#fff",
            borderRadius: 12,
            padding: 16,
            boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            width: "100%",
          }}
        >
          {/* HEADER */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 10,
              marginBottom: 12,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 20 }}>📊</span>
              <div>
                <div style={{ fontWeight: 700, fontSize: 16 }}>
                  {selectedProject.name}
                </div>
                <div style={{ fontSize: 12, color: "#666" }}>
                  Project Details & Export
                </div>
              </div>
            </div>

            {selectedProject.flag && (
              <img
                src={selectedProject.flag}
                alt=""
                style={{
                  width: 36,
                  height: 24,
                  objectFit: "cover",
                  borderRadius: 4,
                  boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
                }}
              />
            )}
          </div>

          {/* ACTIONS */}
          <div
            style={{
              display: "flex",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <button
              onClick={() => exportProjectExcel(selectedProject)}
              disabled={exporting}
              style={{
                ...addUserBtn,
                background: "#28a745",
                flex: "1 1 220px",
                opacity: exporting ? 0.7 : 1,
              }}
            >
              {exporting ? "⏳ Exporting..." : "📥 Export Project Data (Excel)"}
            </button>

            <button
              onClick={() => setSelectedProject(null)}
              style={{
                background: "#e0e0e0",
                border: "none",
                borderRadius: 6,
                padding: "10px 14px",
                cursor: "pointer",
                fontWeight: 600,
                flex: "1 1 120px",
              }}
            >
              ❌ Close
            </button>
          </div>
        </div>
      )}




      {projects.map((p, i) => (
        <div key={p.id} style={projectRow}>
          <span>
            {p.flag && <img src={p.flag} alt="" style={{ width: 24, marginRight: 6 }} />}
            {p.name}
          </span>

          <div style={{ display: "flex", gap: 6 }}>
            <button onClick={() => setSelectedProject(p)} style={reorderBtn}>
              📊
            </button>

            <button onClick={() => move(i, -1)} style={reorderBtn}>⬆️</button>
            <button onClick={() => move(i, +1)} style={reorderBtn}>⬇️</button>
            <button onClick={() => removeProject(p)} style={deleteBtn}>🗑</button>
          </div>
        </div>
      ))}

    </div>
  );
}
const reorderBtn = {
  background: "#ddd",
  border: "none",
  padding: "4px 8px",
  borderRadius: 4,
  cursor: "pointer",
  fontSize: "14px",
};


/* ------------ MODAL ------------ */
function AddUserModal({ newUser, setNewUser, setShowModal, handleAddUser }) {
  return (
    <div style={modalOverlay}>
      <div style={modal}>
        <h3>Add User</h3>

        <input style={input} placeholder="Full Name" value={newUser.displayName} onChange={(e) => setNewUser({ ...newUser, displayName: e.target.value })} />
        <input style={input} placeholder="Email" value={newUser.email} onChange={(e) => setNewUser({ ...newUser, email: e.target.value })} />
        <select style={input} value={newUser.role} onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}>
          <option value="user">User</option>
          <option value="admin">Admin</option>
        </select>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button onClick={() => setShowModal(false)} style={cancelBtn}>Cancel</button>
          <button onClick={handleAddUser} style={addUserBtn}>Save</button>
        </div>
      </div>
    </div>
  );
}

/* ------------ UI Styles ------------ */
const pageStyle = { background: "#f9fafc", minHeight: "100vh", padding: "30px 20px" };
const TabButton = ({ title, active, onClick }) => (
  <button onClick={onClick} style={{
    background: active ? "#0078d7" : "#e3e3e3",
    color: active ? "white" : "#333",
    padding: "10px 18px", borderRadius: 6, border: "none", cursor: "pointer", fontWeight: "bold"
  }}>{title}</button>
);

const headerRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 10,
};
const addUserBtn = { background: "#0078d7", color: "white", border: "none", borderRadius: 6, padding: "8px 14px", cursor: "pointer", fontWeight: "bold" };
const tableWrapper = { overflowX: "auto", background: "white", borderRadius: 10, boxShadow: "0 4px 10px rgba(0,0,0,0.06)" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const theadStyle = { background: "#0078d7", color: "white" };
const th = { padding: "10px 12px", textAlign: "left" };
const td = { padding: "8px 10px", borderBottom: "1px solid #eee" };
const tdCenter = { textAlign: "center", padding: 20 };
const trBorder = { borderBottom: "1px solid #eee" };
const selectInput = { padding: 6, borderRadius: 4 };
const resetBtn = { background: "#ff9f0a", border: "none", borderRadius: 6, padding: "6px 10px", color: "white", cursor: "pointer", fontWeight: "bold" };
const deleteBtn = { background: "#ff004c", border: "none", borderRadius: 6, padding: "6px 10px", color: "white", cursor: "pointer", fontWeight: "bold" };
const modalOverlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 };
const modal = { background: "white", padding: 25, borderRadius: 8, width: "90%", maxWidth: 400 };
const input = { padding: 10, borderRadius: 6, border: "1px solid #bbb", marginBottom: 10 };
const cancelBtn = { background: "#ccc", border: "none", borderRadius: 6, padding: "8px 14px", cursor: "pointer" };
const projectBox = {
  background: "white",
  padding: 20,
  borderRadius: 10,
  width: "100%",
  maxWidth: "100%",
};
const projectRow = { display: "flex", justifyContent: "space-between", padding: "8px 12px", borderBottom: "1px solid #eee" };
